package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_08_08_Day_1
import com.veldekar.components.logs.Log_2026_08_08_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-08-08")
@Composable
public fun Log_2026_08_08(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Dungeon Daddy Giveth",
        ogTitle = "Dungeon Daddy Giveth",
        date = LocalDate(2_026, 8, 8),
        aiHint = "Image shows Goram with a santa hat (joke). Goram is not actually called Dungeon Daddy (joke). Treant in picture is larger and more magical than it actually was.",
        ogDescription = "Goram distributes gifts to the good boys and girls. The heroes hand over the cursed blade, Razorwrath, to Lord Fox before departing up river toward the Dwarven kingdom of Ladikor.",
        ogImage = "images/goramSantaHat.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "shimmer-33", dateString = "Shimmer 33", cardImageSrc = "images/inanAmbush.webp", width = 4_775, height = 1_314)
        Log_2026_08_08_Day_1()
        SessionDayHeader(dayId = "shimmer-34", dateString = "Shimmer 34")
        Log_2026_08_08_Day_2()
        SessionMediaItem(
            image = "images/goramSantaHatMan.webp",
            linkImage = "images/goramSantaHatMan.webp",
            width = 1_200,
            height = 1_739,
        )
        SessionMediaItem(
            image = "images/goramSantaHatBag.webp",
            linkImage = "images/goramSantaHatBag.webp",
            width = 1_200,
            height = 1_841,
        )
        SessionMediaItem(
            image = "images/goramSantaHatPlant.webp",
            linkImage = "images/goramSantaHatPlant.webp",
            width = 1_200,
            height = 1_820,
        )
    }
}
